import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
  <title>Logo</title>
  <g transform="translate(-8.000000, -2.000000)">
    <g transform="translate(11.000000, 5.000000)">
      <polygon
        id="Shape"
        stroke="currentColor"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
        points="39 0 0 22 0 67 39 90 78 68 78 23"
      />

            <g transform="translate(78, 0) scale(-1, 1)">
        <path
          d="M48,35 C48,30 44,28 38,28 C32,28 28,30 26,34 L31,36 C32,33 34,31.5 38,31.5 C42,31.5 44.5,33 44.5,35.5 C44.5,38 42,39.5 37,40.5 C31,41.8 26,44 26,49 C26,54 30,58 38,58 C44,58 47.5,56 49,52 L43.5,50 C42.5,52.5 40.5,54 38,54 C34,54 31.5,52.5 31.5,49.5 C31.5,46.5 34,45 38,44 C44,42.5 48,40.5 48,35 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </g>
</svg>

);

export default IconLogo;
